export interface Professional {
  id?: string;
  personType: number | string;
  name: string;
  cpfCnpj: string;
  contractType: string;
  picture: string;
  // user fields (flattened)
  userId?: string;
  username: string;
  email: string;
  roles: string[];
  // address fields (flattened)
  cep: string;
  city: string;
  streetName: string;
  complement: string;
  neighborhood: string;
  uf: string;
  // contact fields (flattened)
  phone: string;
  cellphone: string;
  // office fields (flattened)
  officeId: string;
  officeName: string;
  // responsibility fields (flattened)
  responsibilityId: string;
  responsibilityName: string;
  accessType: string;
  createdAt: string;
  updatedAt: string;
  deletedAt: string;
}

export interface ProfessionalRequest {
  name: string;
  cpfCnpj: string;
  contractType: ContractType;
  personType: PersonType;
  officeId: string;
  responsibilityId: string;
  supervisorId: string;
  managerId: string;
  accessType: string;
  username: string;
  email: string;
  password: string;
  roles: string[];
}

export interface AddressSearch {
  cep: string;
  logradouro: string;
  complemento: string;
  bairro: string;
  localidade: string;
  uf: string;
  ibge: string;
  gia: string;
  ddd: string;
  siafi: string;
}

export enum Roles {
  ROLE_ADMIN = "ROLE_ADMIN",
  ROLE_USER = "ROLE_USE",
  ROLE_SUPERVISOR = "ROLE_SUPERVISOR",
}

export enum ContractType {
  CLT = "Clt",
  PROFESSIONAL = "Autônomo",
  SUPPLIER = "Prestador de Serviço",
}

export enum PersonType {
  USER = "Profissional",
  SUPERVISOR = "Supervisor",
  MANAGER = "Gerente",
}
